
import PageState from "./state";
import mutations from "./mutations";
import { getModule } from '@/store/store';
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"
let APIS = {
	// 获取订单信息
	getOrderInfo: `get /apis/tts-web-api/v2/voice/clone/h5/order/info`,
  // 支付费用
	payClone: {
		custom: true,
		url: (data: any) => `/apis/tts-web-api/v2/voice/clone/h5/pay`,
		method: 'get'
	},

};


export default {
	...getModule({
		state: new PageState(),
		mutations,
		actions: {},
		APIS,
		name: "voiceClone"
	})
};
